import axios from 'axios';

export class TokensService {
  async getTokensPrices(tokenAddresses) {
    try {
			const prices = await Promise.all(
				tokenAddresses.map(address => axios.get(`${process.env.REACT_APP_API}/v1/xbr/token-prices?address=${address}`))
			)
			return prices
    } catch (error) {
      console.error(error);

      throw error;
    }
  }
}

export const tokensService = new TokensService();
